/* Fathom Thread v1: điều khiển sheet/dialog dùng chung.
   FtSheet.open(el, opener) / FtSheet.close(el). Escape + nút [data-ft-close] + bấm nền để đóng; giữ focus trong sheet;
   đóng thì trả focus về nút đã mở và mở lại cuộn trang. */
(function () {
  'use strict';
  if (window.FtSheet) return;
  var stack = [];
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function visible(n) { return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length); }
  function focusables(el) { return [].filter.call(el.querySelectorAll(FOCUSABLE), visible); }

  function open(el, opener) {
    if (!el || !el.hidden) return;
    el.hidden = false;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    stack.push({ el: el, opener: opener || document.activeElement });
    document.body.classList.add('ft-lock');
    var f = el.querySelector('[data-ft-autofocus]') || focusables(el)[0];
    if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
    el.dispatchEvent(new CustomEvent('ft:open', { bubbles: true }));
  }
  function close(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    var i = stack.map(function (s) { return s.el; }).lastIndexOf(el);
    var item = i > -1 ? stack.splice(i, 1)[0] : null;
    if (!stack.length) document.body.classList.remove('ft-lock');
    if (item && item.opener && document.contains(item.opener)) try { item.opener.focus({ preventScroll: true }); } catch (e) {}
    el.dispatchEvent(new CustomEvent('ft:close', { bubbles: true }));
  }
  document.addEventListener('keydown', function (e) {
    var top = stack[stack.length - 1]; if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); close(top.el); return; }
    if (e.key === 'Tab') {
      var f = focusables(top.el); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    var top = stack[stack.length - 1]; if (!top) return;
    if (e.target === top.el) { close(top.el); return; }
    var c = e.target.closest('[data-ft-close]');
    if (c && top.el.contains(c)) { e.preventDefault(); close(top.el); }
  });
  window.FtSheet = { open: open, close: close };
})();
